"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.immutableAsyncMap = void 0;
const asyncMap_1 = require("./asyncMap");
/**
 * Similar to asyncMap, iterates over a list of items ensuring only
 * 'numberOfConcurrentPromises' items are processed at a time. Returns
 * an array containing the outputs of the workerFunction
 */
async function immutableAsyncMap(maxConcurrentPromises, items, workerFunction) {
    let results = [];
    await (0, asyncMap_1.asyncMap)(maxConcurrentPromises, items, async (item) => {
        const result = await workerFunction(item);
        results = [...results, result];
    });
    return results;
}
exports.immutableAsyncMap = immutableAsyncMap;
